import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { IOnderpand } from '@/model/IOnderpand';
import AppEnergielabelComponentVue from '@/components/energie-label/AppEnergielabelComponent.vue';
import { AppHypotheekMixin } from '../../mixins/AppHypotheekMixin';

@Component({
  components: {
    'app-energielabel': AppEnergielabelComponentVue
  }
})
export default class AppOnderpanden extends Mixins(AppHypotheekMixin, AppFiltersMixin) {
  @Prop()
  public onderpanden!: IOnderpand[];

  public get initialVisible(): boolean {
    return this.onderpanden && this.onderpanden.length === 1 && window.document.body.offsetWidth > 768;
  }
  public get isSingle(): boolean {
    return this.onderpanden && this.onderpanden.length === 1;
  }

  public isEnergielabelBekend(onderpand: IOnderpand): boolean {
    return onderpand.energielabel !== 'Onbekend';
  }
}
